const updateYoutubeEmbed = () => {
  const videoEmbed = document.querySelectorAll(".js-embed");

  if (!videoEmbed) {
    return;
  }
  videoEmbed.forEach((embed) => {
    if ((embed as HTMLIFrameElement).src.includes("youtube-nocookie")) {
      (embed as HTMLIFrameElement).src = (
        embed as HTMLIFrameElement
      ).src.replace("youtube-nocookie", "youtube");
    }
  });
};

const submitForm = () => {
  localStorage.setItem("preference-chosen", "true");
  location.reload();
};

export function renderContent() {
  const pardots = document.querySelectorAll(".pardot-form");
  const pardotWarnings = document.querySelectorAll(".pardot-warning");

  if (window.shouldLoadScripts("functionality-preference")) {
    pardots.forEach((pardot) => {
      pardot.classList.remove("hidden");
    });
    pardotWarnings.forEach((warning) => {
      warning?.classList.add("hidden");
    });
    updateYoutubeEmbed();
  } else {
    pardots.forEach((pardot) => {
      pardot.classList.add("hidden");
    });

    pardotWarnings.forEach((warning) => {
      warning?.classList.remove("hidden");
    });
  }
}

document.addEventListener("afterBlitzInjectAll", () => {
  if (document.querySelector(".js-cookie-banner")) {
    const cookies: String[] = [];
    const banner = document.querySelector(".js-cookie-banner");
    const acceptAll = banner?.querySelector("#accept-preferences");
    const rejectAll = banner?.querySelector("#reject-preferences");
    const confirmPreferences = banner?.querySelector("#submit-button");
    const footerPreferences = document.querySelector(".js-footer-preferences");
    const cookieInputs = banner?.querySelectorAll(".js-preferences");
    const accordion = banner?.querySelector(".js-details");
    const form = document.querySelector<HTMLFormElement>(".cookie-prefs");

    if (window.showManageCookies()) {
      footerPreferences?.classList.remove("hidden");
    } else {
      footerPreferences?.classList.add("hidden");
    }

    if (window.showCookiesPopup()) {
      banner?.classList.remove("hidden");
    } else {
      banner?.classList.add("hidden");
    }

    accordion?.addEventListener("click", () => {
      if (acceptAll?.classList.contains("hidden")) {
        acceptAll?.classList.remove("hidden");
        acceptAll?.classList.add("button");
      } else {
        acceptAll?.classList.add("hidden");
        acceptAll?.classList.remove("button");
      }

      if (rejectAll?.classList.contains("hidden")) {
        rejectAll.classList.remove("hidden");
        rejectAll?.classList.add("button");
      } else {
        rejectAll?.classList.add("hidden");
        rejectAll?.classList.remove("button");
      }
    });

    acceptAll?.addEventListener("click", () => {
      cookieInputs?.forEach((checkbox) => {
        localStorage.setItem(checkbox.id, "true");
        (checkbox as HTMLInputElement).checked = true;
      });
      submitForm();
    });

    rejectAll?.addEventListener("click", () => {
      cookieInputs?.forEach((checkbox) => {
        localStorage.removeItem(checkbox.id);
        (checkbox as HTMLInputElement).checked = false;
      });
      submitForm();
    });

    confirmPreferences?.addEventListener("click", () => {
      cookieInputs?.forEach((checkbox) => {
        if ((checkbox as HTMLInputElement).checked) {
          localStorage.setItem(checkbox.id, "true");
        }
      });
      form?.addEventListener("submit", (e) => {
        e.preventDefault();
        submitForm();
      });
    });

    footerPreferences?.addEventListener("click", () => {
      localStorage.removeItem("preference-chosen");
    });

    cookieInputs?.forEach((checkbox) => {
      if (localStorage.getItem(checkbox.id) === "true") {
        (checkbox as HTMLInputElement).checked = true;
        cookies.push(checkbox.id);
      }

      checkbox?.addEventListener("click", () => {
        if ((checkbox as HTMLInputElement).checked) {
          localStorage.setItem(checkbox.id, "true");
        } else {
          localStorage.removeItem(checkbox.id);
        }
      });
    });

    if (window.hasChosenPreferences()) {
      banner?.classList.add("hidden");
    }

    renderContent();
  }
});
